import { ParameterConfig } from "./parameter-config.model";

export class UpdateNotificationTemplate {
  appType?: string;
  appCategory?: Array<string>;
  appChannel?: string;
  name?: string;
  state!: string;
  configParameters?: ParameterConfig[];
}
